import React, { useState } from "react";
import Layout from "../components/layouts/Layout";

const PartnershipPage = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const partnershipData = {
    overview: {
      title: "成功報酬型ビジネスパートナーシップ",
      subtitle: "共に成長し、共に成功する新しいビジネスモデル",
      description: "DeepTeLLでは、従来の固定費用ではなく、成功報酬型のパートナーシップを提案しています。あなたの成功が私たちの成功。リスクを共有し、リターンを分かち合う、新しい形のビジネス連携です。"
    },
    benefits: [
      {
        icon: "MONEY",
        title: "成功報酬型の料金体系",
        description: "初期費用なし。成果に応じた報酬で、リスクを最小化"
      },
      {
        icon: "TECH",
        title: "最新AI技術へのアクセス",
        description: "量子リザバコンピューティング、カスタムSLMなど最先端技術を活用"
      },
      {
        icon: "TARGET",
        title: "オーダーメイドソリューション",
        description: "あなたのビジネスに完全にカスタマイズされたAIソリューション"
      },
      {
        icon: "PARTNERSHIP",
        title: "長期的パートナーシップ",
        description: "一時的な関係ではなく、継続的な成長を共に目指す"
      },
      {
        icon: "DATA",
        title: "透明な成果指標",
        description: "ROI、効率化率など、明確な指標で成果を測定"
      },
      {
        icon: "SECURITY",
        title: "セキュリティ保証",
        description: "企業秘密の厳格な管理と、安全なAI導入"
      }
    ],
    process: [
      {
        step: 1,
        title: "ヒアリング",
        description: "現在の課題と目標を詳しくお聞きします",
        duration: "1-2週間",
        deliverables: ["課題分析レポート", "目標設定書"]
      },
      {
        step: 2,
        title: "PoC設計",
        description: "概念実証として小規模なプロトタイプを作成",
        duration: "2-4週間",
        deliverables: ["プロトタイプ", "効果測定計画"]
      },
      {
        step: 3,
        title: "効果検証",
        description: "実際の業務でテストし、効果を測定",
        duration: "4-8週間",
        deliverables: ["効果測定レポート", "改善提案書"]
      },
      {
        step: 4,
        title: "本格導入",
        description: "検証結果を基に本格的なシステムを構築",
        duration: "3-6ヶ月",
        deliverables: ["本格システム", "運用マニュアル"]
      },
      {
        step: 5,
        title: "継続的改善",
        description: "運用開始後も継続的にシステムを改善",
        duration: "継続",
        deliverables: ["月次レポート", "改善アップデート"]
      }
    ],
    pricing: {
      model: "成功報酬型",
      structure: [
        {
          phase: "PoC段階",
          cost: "無料",
          description: "概念実証段階では費用は発生しません"
        },
        {
          phase: "導入段階",
          cost: "実コスト削減額の20-30%",
          description: "実際に削減できたコストの一部を報酬として"
        },
        {
          phase: "運用段階",
          cost: "継続的効果の15-25%",
          description: "継続的な効果に対する適正な対価"
        }
      ],
      guarantees: [
        "効果が出なければ費用は一切発生しません",
        "明確なROI指標で透明性を確保",
        "契約期間中のサポートを保証"
      ]
    }
  };

  const dpnData = {
    title: "DPN (DeepTeLL Partner Network)",
    subtitle: "AI時代を共に切り拓くパートナーコミュニティ",
    description: "DPNは、AI技術を活用してビジネスを成長させたい企業や個人のためのコミュニティです。最新情報の共有、技術研修、ネットワーキングを通じて、メンバーの成功を支援します。",
    membership: {
      price: "月額980円",
      features: [
        "毎週の最新AI技術動向レポート",
        "月2回の技術研修セミナー",
        "メンバー限定ネットワーキングイベント",
        "専用Slackコミュニティへの参加",
        "個別技術相談（月1回）",
        "業界別AI活用事例の共有",
        "DeepTeLLサービスの優待割引",
        "技術資料・ホワイトペーパーの提供"
      ]
    },
    events: [
      {
        title: "AI技術トレンドセミナー",
        frequency: "月2回",
        description: "最新のAI技術動向と実用化事例を専門家が解説"
      },
      {
        title: "業界別活用ワークショップ",
        frequency: "四半期1回",
        description: "業界特有の課題に対するAI活用方法を実践的に学習"
      },
      {
        title: "ネットワーキングMeetup",
        frequency: "月1回",
        description: "メンバー同士の交流と情報交換、コラボレーション創出"
      },
      {
        title: "技術相談会",
        frequency: "随時",
        description: "個別の技術的な課題について専門家に直接相談"
      }
    ]
  };

  const caseStudies = [
    {
      title: "製造業A社",
      challenge: "品質管理の自動化",
      solution: "画像認識AIによる不良品検出システム",
      result: "検査時間60%削減、精度95%向上",
      revenue: "年間1,200万円のコスト削減",
      partnership: "削減額の25%を成功報酬として受領"
    },
    {
      title: "小売業B社",
      challenge: "需要予測の精度向上",
      solution: "QRCによる販売予測システム",
      result: "予測精度40%向上、在庫コスト30%削減",
      revenue: "年間800万円のコスト削減",
      partnership: "削減額の20%を成功報酬として受領"
    },
    {
      title: "サービス業C社",
      challenge: "顧客対応の効率化",
      solution: "カスタムSLM「Hamster」チャットボット",
      result: "対応時間50%削減、顧客満足度20%向上",
      revenue: "年間600万円の人件費削減",
      partnership: "削減額の30%を成功報酬として受領"
    }
  ];

  return (
    <Layout 
      title="パートナーシップ" 
      subtitle="共に成長し、共に成功する新しいビジネス連携"
    >
      {/* ヒーローセクション */}
      <section style={{ 
        padding: '65px 0 80px',
        background: 'linear-gradient(135deg, #1e40af 0%, #1d4ed8 50%, #3b82f6 100%)',
        position: 'relative'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2" style={{ textAlign: 'center' }}>
              <p style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '20px', marginBottom: '40px' }}>
                リスクを共有し、成功を分かち合う<br />
                新しい形のビジネス連携を始めませんか？
              </p>
              
              <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', flexWrap: 'wrap' }}>
                <a href="#contact-form" className="btn btn-custom btn-lg" style={{ 
                  background: 'rgba(255, 255, 255, 0.2)',
                  border: '2px solid white',
                  color: 'white'
                }}>
                  🚀 パートナーシップを申し込む
                </a>
                <a href="#dpn-community" className="btn btn-custom btn-lg" style={{ 
                  background: 'white',
                  border: '2px solid white',
                  color: '#1e40af'
                }}>
                                          DPNコミュニティに参加
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* タブナビゲーション */}
      <section style={{ padding: '40px 0', backgroundColor: '#0f172a' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center">
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px' }}>
                  {[
                                          { key: 'overview', label: 'パートナーシップ概要', icon: 'Partner' },
                                          { key: 'process', label: '導入プロセス', icon: 'Process' },
                                          { key: 'pricing', label: '料金体系', icon: 'Money' },
                                          { key: 'dpn', label: 'DPNコミュニティ', icon: 'Group' },
                    { key: 'cases', label: '成功事例', icon: 'Chart' }
                  ].map((tab) => (
                    <button
                      key={tab.key}
                      onClick={() => setActiveTab(tab.key)}
                      style={{
                        padding: '12px 24px',
                        borderRadius: '25px',
                        border: '1px solid rgba(59, 130, 246, 0.3)',
                        background: activeTab === tab.key ? '#3b82f6' : 'transparent',
                        color: activeTab === tab.key ? 'white' : '#cbd5e1',
                        cursor: 'pointer',
                        transition: 'all 0.3s',
                        fontSize: '16px'
                      }}
                    >
                      {tab.icon} {tab.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* パートナーシップ概要 */}
      {activeTab === 'overview' && (
        <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2" style={{ textAlign: 'center', marginBottom: '60px' }}>
                <h2 style={{ color: '#f1f5f9', marginBottom: '20px' }}>
                  {partnershipData.overview.title}
                </h2>
                <p style={{ color: '#94a3b8', fontSize: '18px', marginBottom: '30px' }}>
                  {partnershipData.overview.subtitle}
                </p>
                <p style={{ color: '#cbd5e1', lineHeight: '1.6' }}>
                  {partnershipData.overview.description}
                </p>
              </div>
            </div>

            <div className="row">
              {partnershipData.benefits.map((benefit, index) => (
                <div key={index} className="col-md-4" style={{ marginBottom: '40px' }}>
                  <div style={{ 
                    padding: '30px',
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px',
                    textAlign: 'center'
                  }}>
                    <div style={{ fontSize: '48px', marginBottom: '20px' }}>
                      {benefit.icon}
                    </div>
                    <h4 style={{ color: '#f1f5f9', marginBottom: '15px' }}>
                      {benefit.title}
                    </h4>
                    <p style={{ color: '#cbd5e1', lineHeight: '1.6' }}>
                      {benefit.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* 導入プロセス */}
      {activeTab === 'process' && (
        <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2" style={{ textAlign: 'center', marginBottom: '60px' }}>
                <h2 style={{ color: '#f1f5f9', marginBottom: '20px' }}>
                                      導入プロセス
                </h2>
                <p style={{ color: '#94a3b8', fontSize: '18px' }}>
                  段階的なアプローチで、確実に成果を実現します
                </p>
              </div>
            </div>

            <div className="row">
              {partnershipData.process.map((step, index) => (
                <div key={step.step} className="col-md-12" style={{ marginBottom: '30px' }}>
                  <div style={{ 
                    padding: '30px',
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    <div style={{ 
                      width: '60px',
                      height: '60px',
                      background: '#3b82f6',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '30px',
                      fontSize: '24px',
                      color: 'white',
                      fontWeight: '700'
                    }}>
                      {step.step}
                    </div>
                    <div style={{ flex: 1 }}>
                      <h4 style={{ color: '#f1f5f9', marginBottom: '10px' }}>
                        {step.title}
                      </h4>
                      <p style={{ color: '#cbd5e1', marginBottom: '15px' }}>
                        {step.description}
                      </p>
                      <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                        <span style={{ 
                          background: 'rgba(16, 185, 129, 0.2)',
                          color: '#10b981',
                          padding: '4px 12px',
                          borderRadius: '12px',
                          fontSize: '12px'
                        }}>
                          期間: {step.duration}
                        </span>
                        <div>
                          <span style={{ color: '#94a3b8', fontSize: '12px' }}>成果物: </span>
                          {step.deliverables.map((deliverable, index) => (
                            <span key={index} style={{ 
                              background: 'rgba(249, 115, 22, 0.2)',
                              color: '#f97316',
                              padding: '2px 8px',
                              borderRadius: '8px',
                              fontSize: '11px',
                              marginRight: '5px'
                            }}>
                              {deliverable}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* 料金体系 */}
      {activeTab === 'pricing' && (
        <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2" style={{ textAlign: 'center', marginBottom: '60px' }}>
                <h2 style={{ color: '#f1f5f9', marginBottom: '20px' }}>
                                      成功報酬型料金体系
                </h2>
                <p style={{ color: '#94a3b8', fontSize: '18px', marginBottom: '30px' }}>
                  成果が出なければ、費用は一切発生しません
                </p>
              </div>
            </div>

            <div className="row">
              {partnershipData.pricing.structure.map((pricing, index) => (
                <div key={index} className="col-md-4" style={{ marginBottom: '30px' }}>
                  <div style={{ 
                    padding: '30px',
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px',
                    textAlign: 'center'
                  }}>
                    <h4 style={{ color: '#3b82f6', marginBottom: '15px' }}>
                      {pricing.phase}
                    </h4>
                    <div style={{ fontSize: '36px', color: '#f1f5f9', fontWeight: '700', marginBottom: '15px' }}>
                      {pricing.cost}
                    </div>
                    <p style={{ color: '#cbd5e1', lineHeight: '1.6' }}>
                      {pricing.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div className="row" style={{ marginTop: '40px' }}>
              <div className="col-md-8 col-md-offset-2">
                <div style={{ 
                  padding: '30px',
                  background: 'rgba(16, 185, 129, 0.1)',
                  border: '1px solid rgba(16, 185, 129, 0.3)',
                  borderRadius: '12px'
                }}>
                  <h4 style={{ color: '#10b981', marginBottom: '20px', textAlign: 'center' }}>
                    🛡️ 保証内容
                  </h4>
                  <ul style={{ color: '#cbd5e1', lineHeight: '1.8', paddingLeft: '20px' }}>
                    {partnershipData.pricing.guarantees.map((guarantee, index) => (
                      <li key={index} style={{ marginBottom: '10px' }}>
                        ✅ {guarantee}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* DPNコミュニティ */}
      {activeTab === 'dpn' && (
        <section id="dpn-community" style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2" style={{ textAlign: 'center', marginBottom: '60px' }}>
                <h2 style={{ color: '#f1f5f9', marginBottom: '20px' }}>
                                      {dpnData.title}
                </h2>
                <p style={{ color: '#94a3b8', fontSize: '18px', marginBottom: '30px' }}>
                  {dpnData.subtitle}
                </p>
                <p style={{ color: '#cbd5e1', lineHeight: '1.6' }}>
                  {dpnData.description}
                </p>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div style={{ 
                  padding: '40px',
                  background: 'rgba(30, 41, 59, 0.8)',
                  border: '1px solid rgba(59, 130, 246, 0.2)',
                  borderRadius: '12px',
                  textAlign: 'center'
                }}>
                  <h3 style={{ color: '#3b82f6', marginBottom: '20px' }}>
                    メンバーシップ
                  </h3>
                  <div style={{ fontSize: '48px', color: '#f1f5f9', fontWeight: '700', marginBottom: '20px' }}>
                    {dpnData.membership.price}
                  </div>
                  <ul style={{ color: '#cbd5e1', textAlign: 'left', lineHeight: '1.8' }}>
                    {dpnData.membership.features.map((feature, index) => (
                      <li key={index} style={{ marginBottom: '10px' }}>
                        {feature}
                      </li>
                    ))}
                  </ul>
                  <button className="btn btn-custom btn-lg" style={{ 
                    marginTop: '30px',
                    background: '#3b82f6',
                    border: 'none',
                    color: 'white',
                    width: '100%'
                  }}>
                    今すぐ参加する
                  </button>
                </div>
              </div>

              <div className="col-md-6">
                <h3 style={{ color: '#f1f5f9', marginBottom: '30px' }}>
                  定期イベント
                </h3>
                {dpnData.events.map((event, index) => (
                  <div key={index} style={{ 
                    padding: '20px',
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '8px',
                    marginBottom: '20px'
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                      <h5 style={{ color: '#3b82f6', margin: 0 }}>
                        {event.title}
                      </h5>
                      <span style={{ 
                        background: 'rgba(16, 185, 129, 0.2)',
                        color: '#10b981',
                        padding: '4px 12px',
                        borderRadius: '12px',
                        fontSize: '12px'
                      }}>
                        {event.frequency}
                      </span>
                    </div>
                    <p style={{ color: '#cbd5e1', fontSize: '14px', margin: 0 }}>
                      {event.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* 成功事例 */}
      {activeTab === 'cases' && (
        <section style={{ padding: '80px 0', backgroundColor: '#1e293b' }}>
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2" style={{ textAlign: 'center', marginBottom: '60px' }}>
                <h2 style={{ color: '#f1f5f9', marginBottom: '20px' }}>
                  パートナーシップ成功事例
                </h2>
                <p style={{ color: '#94a3b8', fontSize: '18px' }}>
                  実際の成果と成功報酬の事例をご紹介
                </p>
              </div>
            </div>

            <div className="row">
              {caseStudies.map((caseStudy, index) => (
                <div key={index} className="col-md-4" style={{ marginBottom: '30px' }}>
                  <div style={{ 
                    padding: '30px',
                    background: 'rgba(30, 41, 59, 0.8)',
                    border: '1px solid rgba(59, 130, 246, 0.2)',
                    borderRadius: '12px'
                  }}>
                    <h4 style={{ color: '#3b82f6', marginBottom: '20px' }}>
                      {caseStudy.title}
                    </h4>
                    
                    <div style={{ marginBottom: '15px' }}>
                      <h6 style={{ color: '#f1f5f9', fontSize: '14px', marginBottom: '5px' }}>課題</h6>
                      <p style={{ color: '#cbd5e1', fontSize: '13px' }}>
                        {caseStudy.challenge}
                      </p>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                      <h6 style={{ color: '#f1f5f9', fontSize: '14px', marginBottom: '5px' }}>ソリューション</h6>
                      <p style={{ color: '#cbd5e1', fontSize: '13px' }}>
                        {caseStudy.solution}
                      </p>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                      <h6 style={{ color: '#f1f5f9', fontSize: '14px', marginBottom: '5px' }}>結果</h6>
                      <p style={{ color: '#10b981', fontSize: '13px', fontWeight: '600' }}>
                        {caseStudy.result}
                      </p>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                      <h6 style={{ color: '#f1f5f9', fontSize: '14px', marginBottom: '5px' }}>売上効果</h6>
                      <p style={{ color: '#f97316', fontSize: '16px', fontWeight: '700' }}>
                        {caseStudy.revenue}
                      </p>
                    </div>

                    <div style={{ 
                      padding: '15px',
                      background: 'rgba(59, 130, 246, 0.1)',
                      borderRadius: '8px'
                    }}>
                      <h6 style={{ color: '#3b82f6', fontSize: '12px', marginBottom: '5px' }}>パートナーシップ実績</h6>
                      <p style={{ color: '#cbd5e1', fontSize: '12px', margin: 0 }}>
                        {caseStudy.partnership}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* お問い合わせフォーム */}
      <section id="contact-form" style={{ 
        padding: '80px 0',
        background: 'linear-gradient(135deg, #1e40af 0%, #1d4ed8 50%, #3b82f6 100%)'
      }}>
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2" style={{ textAlign: 'center' }}>
              <h2 style={{ color: 'white', marginBottom: '20px' }}>
                パートナーシップを始めませんか？
              </h2>
              <p style={{ color: 'rgba(255, 255, 255, 0.9)', marginBottom: '40px', fontSize: '18px' }}>
                まずは無料相談から。あなたのビジネス課題をお聞かせください。
              </p>
              
              <div style={{ display: 'flex', justifyContent: 'center', gap: '15px', flexWrap: 'wrap' }}>
                <a href="/contact" className="btn btn-custom btn-lg" style={{ 
                  background: 'rgba(255, 255, 255, 0.2)',
                  border: '2px solid white',
                  color: 'white'
                }}>
                                      無料相談を申し込む
                </a>
                <a href="mailto:partnership@deeptell.co.jp" className="btn btn-custom btn-lg" style={{ 
                  background: 'white',
                  border: '2px solid white',
                  color: '#1e40af'
                }}>
                  ✉️ 直接メールで相談
                </a>
              </div>

              <div style={{ marginTop: '40px', color: 'rgba(255, 255, 255, 0.8)' }}>
                                  <p>お電話でのお問い合わせ: 03-1234-5678</p>
                <p>メール: partnership@deeptell.co.jp</p>
                                  <p>営業時間: 平日 9:00-18:00</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default PartnershipPage; 